module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("“[This is] a terrific series of French noir novels, a Marseilles trilogy of sun-baked bad guys and beautiful women, smart cops and mean situations. Mr. Izzo was a marvelous food writer in addition to being a poet of violence and regret. His books are filled with winning descriptions of Provençal meals run through with the flavors of north Africa, Italy, Greece.”")]), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("—Sam Sifton, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New York Times")])]), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("“Caught between pride and crime, racism and fraternity, tragedy and light, messy urbanization and generous beauty, the city is for Jean-Claude Izzo a Utopia, an ultimate port of call for exiles. There Montale, like Mr. Izzo himself perhaps, is torn between fatalism and revolt, despair and sensualism.”––"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Economist")])]), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("“What makes Izzo’s work haunting is his extraordinary ability to convey the tastes and smells of Marseilles, and the way memory and obligation dog every step his hero takes.”—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The New Yorker")])]), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("“In Izzo’s books . . . Marseilles is a ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ville selon nos coeurs")]), _vm._v(",’ a city in tune with our hearts, as we can read in the penultimate sentence of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Total Chaos")]), _vm._v(". A cosmopolitan, maritime city, greedy, sensual and warm, but undermined by racism, hatred, money, mafia, and religious fundamentalism––and passive complicity in the face of these scourges.”––Michel Samson, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Slow Food")])]), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("“Jean-Claude Izzo’s Marseille trilogy . . . delve deep into the guts of multiracial Marseilles, a city that is at once a hopeful symbol of the Mediterranean’s rich cultural past and an urban dystopia burdened by unemployment, racism and violence . . . Noir at its finest: compelling, sophisticated literature with a biting social edge.”—Hirsh Sawhney, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Times Literary Supplement")])]), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("“Like all tragic noir heroes, Montale treads a dangerously narrow line between triumphant savior and doomed avenger.”—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Village Voice")])]), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Total Chaos")]), _vm._v(" is undeniably literature . . . Part of this is due to Izzo’s amazing characterization . . . Izzo takes a convention of noir—the lost soul who finds himself in vengeance—and packs it with enough realism to make it utterly lifelike . . . "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Total Chaos")]), _vm._v(" is a noir through and through, but it feels so real that it reminds us that the clichés of noir were originally drawn from real life.”—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Quarterly Conversation")])]), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("“A few years ago I was planning a trip to Madrid and Paris from Los Angeles. I was also deep into Jean-Claude Izzo’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Total Chaos")]), _vm._v(" . . . By the time I finished the book, I had replaced the Paris leg of my trip with Marseilles. I’d found Lagavulin, the main character’s scotch of choice. (Mine was always Laphroaig.) And a whole lot of interesting jazz . . . The story had leapt out from the book and into my life.”—Valla Vakili, CEO, Small Demons")]), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("“Like the best American practitioners in the genre, Izzo refrains from any sugarcoating of the city he depicts or the broken and imperfect men and women who people it.”—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Publishers Weekly")])]), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("“Jean-Claude Izzo’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Total Chaos")]), _vm._v(" is a marvelous noir novel in which passions and feelings are thrown into the narrative mix without reserve and without gratuitousness.”––"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("La Repubblica")])]), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Total Chaos")]), _vm._v(" . . . draws from the deep, dark well of noir . . . Izzo’s plot is labyrinthine, but his novel is rich, ambitious and passionate, and his sad, loving portrait of his native city is amazing.”—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Washington Post")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-221fafdb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/solea_00000.vue
// module id = 60
// module chunks = 0